import { render, staticRenderFns } from "./RolesEditor.vue?vue&type=template&id=9c1b1fbc&scoped=true&"
import script from "./RolesEditor.vue?vue&type=script&lang=js&"
export * from "./RolesEditor.vue?vue&type=script&lang=js&"
import style0 from "./RolesEditor.vue?vue&type=style&index=0&id=9c1b1fbc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c1b1fbc",
  null
  
)

export default component.exports